import React from 'react';
import { Alert } from 'reactstrap';

const NotificationBanner = ({ 
  type = 'error', // 'error' or 'success'
  message, 
  onClose, 
  show = true 
}) => {
  if (!show || !message) return null;

  const getAlertColor = () => {
    return type === 'error' ? 'danger' : 'success';
  };

  const getIcon = () => {
    return type === 'error' ? 'fas fa-exclamation-triangle' : 'fas fa-check-circle';
  };

  const getBackgroundStyle = () => {
    if (type === 'error') {
      return {
        backgroundColor: '#f26c7f',
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        padding: '15px 20px',
        margin: '15px 20px',
        boxShadow: '0 2px 8px rgba(242, 108, 127, 0.3)'
      };
    } else {
      return {
        backgroundColor: '#28a745',
        border: 'none',
        borderRadius: '8px',
        color: 'white',
        padding: '15px 20px',
        margin: '15px 20px',
        boxShadow: '0 2px 8px rgba(40, 167, 69, 0.3)'
      };
    }
  };

  return (
    <div style={getBackgroundStyle()}>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <i className={`${getIcon()} mr-3`} style={{ fontSize: '1.2rem' }} />
          <span style={{ fontWeight: '500', fontSize: '1rem' }}>
            {message}
          </span>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              fontSize: '1.2rem',
              cursor: 'pointer',
              padding: '0',
              marginLeft: '15px',
              opacity: '0.8',
              transition: 'opacity 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.8'}
            title="Close notification"
          >
            <i className="fas fa-times" />
          </button>
        )}
      </div>
    </div>
  );
};

export default NotificationBanner;
